(function() {
    'use strict';

    angular.module('AuthTokenHttpInterceptor', ['MW.Configuration'])
        .factory('AuthTokenHttpInterceptor', ['$q', '$cookies', '$window', 'ACCOUNTS_APP_URL', '$location', 'ICM_ASSETS_URL', function($q, $cookies, $window, ACCOUNTS_APP_URL, $location, ICM_ASSETS_URL) {
            return {
                request: function(req) {
                    var cookie;
                    // if we dont have an auth header, try to add one
                    if(!req.headers || !req.headers.Authorization) {
                        cookie = $cookies.getObject('gydaToken');

                        // if we dont have a token in the cookie or the query params, logout
                        // else store it & add it to the header
                        if(cookie && cookie.token) {
                            req.headers.Authorization = cookie.token;
                        } else if($location.search().auth) {
                            req.headers.Authorization = $location.search().auth;
                            $cookies.putObject('gydaToken', {token: $location.search().auth});
                        } else {
                            $window.location.href = ACCOUNTS_APP_URL + '/logout';
                            return req;
                        }
                    }

                    // workaround for https://github.com/meltwater/gaf-ng-components/issues/608
                    // if we include the autho token to assests.io, all requests fail.
                    if(req.url.startsWith(ICM_ASSETS_URL) && req.headers || req.skipAuthInterceptor || req.url.startsWith('https://assets.meltwater.io/icm-web-assets/static/img')) {
                        // found a strange case where the auth header comes in lower case, and sneaks by...
                        delete req.headers.Authorization;
                        delete req.headers.authorization;
                    }

                    return req;
                },

                responseError: (rejection)=>{
                    if(rejection.status === 401) {
                        $window.location.href = ACCOUNTS_APP_URL + '/logout';
                    } else {
                        return $q.reject(rejection);
                    }
                }
            };
        }]);
}());
